export const APP_TITLE = 'mobile';
export const APP_DESCRIPTION = 'apps faster!';
export const API_URL = '';
export const APP_API_URL = 'https://api.keenflous.nl/api';
export const APP_APP_URL = 'https://api.keenflous.nl';
